import { FC, useMemo } from 'react';

import { GenericSeason, SequentialSeason } from '../../contentStack.types';
import { OnSelectVariant } from '../../hooks/useContentStackEventHandlers';

import { GenericSeriesSection } from './GenericSeriesSection';

type SeasonSectionProps = {
  seriesData: {
    seasons: SequentialSeason[];
  };
  onClickVariant: OnSelectVariant;
};

export const SequentialSeriesSection: FC<SeasonSectionProps> = ({ seriesData, onClickVariant }) => {
  const mappedData = useMemo(() => {
    const seasons = seriesData.seasons.map(
      (s): GenericSeason => ({
        id: s.link.split(':').pop()!,
        link: s.link,
        label: s.seasonNo,
        episodeCount: s.episodeCount,
        defaultSelected: s.defaultSelected,
        defaultSelectedEpisodeIndex: s.defaultSelectedEpisodeIndex,
      })
    );
    return { seasons, type: 'sequential' } as const;
  }, [seriesData.seasons]);
  return <GenericSeriesSection seriesData={mappedData} onClickVariant={onClickVariant} />;
};
